import {
  CUSTOM_ELEMENTS_SCHEMA,
  NO_ERRORS_SCHEMA,
  NgModule,
} from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterComponent } from './footer/footer.component';
import { HeaderComponent } from './header/header.component';
import { MaterialModule } from '../material/material.module';
import { RouterModule } from '@angular/router';
import { AccountStatusBarComponent } from './account-status-bar/account-status-bar.component';
import { AccountSummaryComponent } from './account-summary/account-summary.component';
import { MatIconModule } from '@angular/material/icon';
import { HelpDialogComponent } from './help-dialog/help-dialog.component';
import { SkeletonComponent } from './skeleton/skeleton.component';


@NgModule({
  declarations: [
    FooterComponent, 
    HeaderComponent, 
    AccountStatusBarComponent, 
    AccountSummaryComponent, 
    HelpDialogComponent,
    SkeletonComponent,
  ],
  imports: [CommonModule, RouterModule, MaterialModule, MatIconModule],
  exports: [
    FooterComponent, 
    HeaderComponent,
    MaterialModule,
    AccountStatusBarComponent,
    AccountSummaryComponent,
    SkeletonComponent,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA, NO_ERRORS_SCHEMA],
})
export class SharedModule {}
